import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { PlanSummary, InstStatus, eur, itDate } from "@/components/modular/PaymentParts";

export default function PortalePagamenti() {
  const { data, error } = useQuery({ queryKey: ["my-payments"], queryFn: async () => (await api.get("/modular-payments/me")).data, retry: false });
  if (error) return <div className="p-10 text-sm text-stone-500" data-testid="payments-not-available">{error.response?.data?.detail || "Sezione non disponibile"}</div>;
  if (!data) return <div className="p-10 text-sm text-stone-400">Caricamento…</div>;
  const p = data.plan;
  return (
    <div className="p-4 sm:p-6 md:p-10 max-w-[900px] mx-auto space-y-5" data-testid="portal-payments-page">
      <PageHeader title="Posizione contabile" subtitle="Le rate del tuo percorso modulare: scadenze, pagamenti registrati e importo residuo."/>
      {!p ? (
        <Card className="p-6 border border-stone-200 rounded-xl shadow-none text-sm text-stone-600" data-testid="payments-empty">Non è ancora presente un piano di pagamento. Per informazioni scrivi alla segreteria.</Card>
      ) : (
        <>
          <Card className="p-5 border border-stone-200 rounded-xl shadow-none"><PlanSummary plan={p}/></Card>
          <Card className="border border-stone-200 rounded-xl shadow-none divide-y divide-stone-100" data-testid="payments-installments">
            {p.installments.map((i) => (
              <div key={i.n} className="p-4 flex items-center gap-3" data-testid={`my-inst-${i.n}`}>
                <div className="w-9 h-9 rounded-full bg-stone-100 grid place-items-center text-sm font-semibold text-[#1C352D] shrink-0">{i.n}</div>
                <div className="flex-1 min-w-0 text-sm">
                  <div className="font-medium">{eur(i.amount)}</div>
                  <div className="text-xs text-stone-500">{i.paid_at ? `Pagata il ${itDate(i.paid_at)}` : `Scadenza ${itDate(i.due_date)}`}</div>
                </div>
                <InstStatus s={i.status} testId={`my-inst-status-${i.n}`}/>
              </div>
            ))}
          </Card>
          {(data.iban || data.paypal_link || data.card_link) && p.residual > 0 && (
            <Card className="p-4 border border-stone-200 rounded-xl shadow-none text-sm" data-testid="payments-iban">
              <div className="text-[11px] uppercase tracking-widest text-stone-500 mb-1">Come pagare</div>
              Bonifico bancario su <b className="font-mono break-all">{data.iban}</b>{data.account_holder && <> intestato a <b>{data.account_holder}</b></>}. Indica nella causale il numero della rata e il tuo nome.
              {(data.paypal_link || data.card_link) && <div className="flex flex-wrap gap-2 mt-3">
                {data.paypal_link && <a href={data.paypal_link} target="_blank" rel="noreferrer" className="px-3 py-1.5 rounded-full bg-[#0070BA] text-white text-xs" data-testid="payments-paypal">Paga con PayPal</a>}
                {data.card_link && <a href={data.card_link} target="_blank" rel="noreferrer" className="px-3 py-1.5 rounded-full bg-[#1C352D] text-white text-xs" data-testid="payments-card">Paga con carta</a>}
              </div>}
            </Card>
          )}
        </>
      )}
    </div>
  );
}
